module.exports = __webpack_public_path__ + "static/media/logo_login_jump_car.28633334.svg";